var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMailMove = function SvgMailMove(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H4v12h9v2H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h16q.824 0 1.413.588Q22 5.175 22 6v7h-2zM4 6v12-5 .075zm8 5 8-5v2l-7.475 4.675q-.25.15-.525.15-.274 0-.525-.15L4 8V6zm7.175 9H16a.97.97 0 0 1-.713-.288A.97.97 0 0 1 15 19q0-.424.287-.712A.97.97 0 0 1 16 18h3.175l-.9-.9a.92.92 0 0 1-.287-.7q.012-.4.312-.7.3-.275.7-.287.4-.013.7.287l2.6 2.6q.3.3.3.7t-.3.7l-2.6 2.6a.98.98 0 0 1-.687.287.93.93 0 0 1-.713-.287.95.95 0 0 1-.275-.7q0-.425.275-.7z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMailMove);
export { ForwardRef as ReactComponent };